import { EmployeeGroupBranchDetailsInput } from './employee-group-branch-details-input.model';
import { EmployeeGroupEmployeeDetailsInput } from './employee-group-employee-details-input.model';


export class EmployeeGroupUpdateInput implements IEmployeeGroupUpdateInput {
    /** The auto-generated id of the employee group master */
    employeeGroupId!: number;
    /** The auto-generated id of the employee master */
    companyDetailsId!: number;
    /** The branch details type must be one of "All" or "Select" */
    branchDetailType!: string;
    /** The user group name with 255 character limit */
    employeeGroupName!: string;
    /** The description with 5000 character limit */
    description!: string;
    branchOptions!: EmployeeGroupBranchDetailsInput[];
    employeeOptions!: EmployeeGroupEmployeeDetailsInput[];

    constructor(data?: IEmployeeGroupUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeGroupId = _data["employeeGroupId"];
            this.companyDetailsId = _data["companyDetailsId"];
            this.branchDetailType = _data["branchDetailType"];
            this.employeeGroupName = _data["employeeGroupName"];
            this.description = _data["description"];
            if (Array.isArray(_data["branchOptions"])) {
                this.branchOptions = [] as any;
                for (let item of _data["branchOptions"])
                    this.branchOptions!.push(EmployeeGroupBranchDetailsInput.fromJS(item));
            }
            if (Array.isArray(_data["employeeOptions"])) {
                this.employeeOptions = [] as any;
                for (let item of _data["employeeOptions"])
                    this.employeeOptions!.push(EmployeeGroupEmployeeDetailsInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeGroupUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeGroupId"] = this.employeeGroupId;
        data["companyDetailsId"] = this.companyDetailsId;
        data["branchDetailType"] = this.branchDetailType;
        data["employeeGroupName"] = this.employeeGroupName;
        data["description"] = this.description;
        if (Array.isArray(this.branchOptions)) {
            data["branchOptions"] = [];
            for (let item of this.branchOptions)
                data["branchOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeOptions)) {
            data["employeeOptions"] = [];
            for (let item of this.employeeOptions)
                data["employeeOptions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEmployeeGroupUpdateInput {
    /** The auto-generated id of the employee group master */
    employeeGroupId: number;
    /** The auto-generated id of the employee master */
    companyDetailsId: number;
    /** The branch details type must be one of "All" or "Select" */
    branchDetailType: string;
    /** The user group name with 255 character limit */
    employeeGroupName: string;
    /** The description with 5000 character limit */
    description: string;
    branchOptions: EmployeeGroupBranchDetailsInput[];
    employeeOptions: EmployeeGroupEmployeeDetailsInput[];
}

